import svgUrl from "ni:svgr;jA4xyCuHX-uMGc19-Kc9FMA35AqSb5VB6alkeFSdF4c";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiSortByDescendingSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M1.5 3a.5.5 0 0 0 0 1h12a.5.5 0 0 0 0-1h-12Zm0 3a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7ZM1 9.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Zm.5 2.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiSortByDescendingSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiSortByDescendingSIcon)";
}